import PropTypes from 'prop-types';
import { convertToWebPUrl } from '@/utils/productUtils';
import styles from './CarouselMobile.module.scss';

// Took from intrinsic size of images
const CAROUSEL_MOBILE_IMAGE_WIDTH = 960;
const CAROUSEL_MOBILE_IMAGE_HEIGHT = 440;

const CarouselMobile = ({ onClickSlide, slides }) =>
	slides?.length
		? slides.map((image, index) => {
				const isFirstSlide = index === 0;

				return (
					<a
						key={image._id}
						href={image.urlDest}
						aria-label={image.alt}
						onClick={() => onClickSlide(image, index)}
						data-test-id="carousel-mobile-link"
					>
						<picture>
							<source srcSet={convertToWebPUrl(image.imgS)} type="image/webp" />
							<img
								className={styles['carousel-image']}
								src={image.imgS}
								alt={image.alt}
								height={CAROUSEL_MOBILE_IMAGE_HEIGHT}
								width={CAROUSEL_MOBILE_IMAGE_WIDTH}
								loading={isFirstSlide ? 'eager' : 'lazy'}
								fetchPriority={isFirstSlide ? 'high' : undefined}
								decoding={isFirstSlide ? undefined : 'async'}
							/>
						</picture>
					</a>
				);
			})
		: null;

CarouselMobile.propTypes = {
	onClickSlide: PropTypes.func.isRequired,
	slides: PropTypes.array.isRequired,
};

export default CarouselMobile;
